import CheckIcon from '@mui/icons-material/Check';

import './JxCheckbox.css'; // box paint + label + focus ring, single concern (check on/off)

/**
 * JxCheckbox — themed checkbox. Native input kept underneath for accessibility/keyboard,
 * visually hidden — .jx-checkbox-box is what's actually painted.
 *
 * @param {string} id
 * @param {boolean} checked
 * @param {(checked: boolean) => void} onChange
 * @param {string} [label]
 * @param {boolean} disabled
 */
export default function JxCheckbox({ id, checked, onChange, label, disabled = false }) {
    return (
        <label htmlFor={id} className={`jx-checkbox-wrap${disabled ? ' jx-checkbox-disabled' : ''}`}>
            <input
                id={id}
                type="checkbox"
                className="jx-checkbox-native"
                checked={!!checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <span className={`jx-checkbox-box${checked ? ' jx-checkbox-box-checked' : ''}`}>
                {checked && <CheckIcon className="jx-checkbox-check-icon" sx={{ fontSize: 12 }} />}
            </span>
            {label && <span className="jx-checkbox-label">{label}</span>}
        </label>
    );
}
